import React from "react";
import { useTranslation } from "@edreamsodigeo/frontend-core";
import { Heading } from "@edreamsodigeo/prisma-design-system";
const ValuePropositionHeader = () => {
  const {
    t
  } = useTranslation();
  const textColor = "neutral.90";
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
    fontSize: ["type.5", "40px"],
    color: textColor
  }, t("supportarea.mytripslogin.banner.title.1")), /*#__PURE__*/React.createElement(Heading, {
    fontSize: ["type.5", "40px"],
    weight: "medium",
    color: textColor
  }, t("supportarea.mytripslogin.banner.title.2")));
};
export default ValuePropositionHeader;